import { createQuery } from '@tanstack/svelte-query';
import { QUERY_KEY_SHORTLINK_BULK_UPLOADS } from '../constants';
import { client } from '../lib/client';

const getShortlinkBulkUploads = async () => {
  const response = await client.get('/api/get-shortlink-bulk-uploads');
  return response.data.objects || [];
};

const getShortlinkBulkUploadsQuery = {
  queryKey: [QUERY_KEY_SHORTLINK_BULK_UPLOADS],
  queryFn: getShortlinkBulkUploads,
  staleTime: Infinity,
};

export const queryShortlinkBulkUploads = () =>
  createQuery(getShortlinkBulkUploadsQuery);
